<template>
  <div>
    <router-link class="come-back" to="/admin/nomination">
      <div></div>
      Вернуться назад
    </router-link>

    <h2 class="title_categories">
      {{ isEdit ? `Редактирование номинации №${$route.params.id}` : 'Создание номинации' }}
    </h2>
    <tricolor-line class="card_containet__tricolor"/>

    <form @submit.prevent="createNomination" ref="createNomination">
        <div class="content-sb">
          <p>Номинация<span>*</span></p>
          <input required placeholder="Введите номинацию" v-model="contactData.title" type="text" name="title" class="input blue">
        </div>
        <div class="content-sb">
          <p>Описание<span>*</span></p>
          <input required placeholder="Введите описание" v-model="contactData.description" type="text" name="description" class="input blue">
        </div>
        <div class="content-sb">
          <p>Изображение<span>*</span></p>
          <custom-drop-zone :name="'preview_photo'"
                @setFile="setFile($event)"
                :uploaded-blob="previewBlob"/>
        </div>

      <footer class="content-sb btns-create-form">
        <router-link to="/admin/nomination" class="btn-white">Отмена</router-link>
        <input type="submit" class="btn-blue" value="Сохранить"/>
      </footer>
    </form>
  </div>
</template>

<script>
import TricolorLine from '@/components/TricolorLine'
import CustomDropZone from '@/components/Admin/CustomDropZone'

export default {
  name: 'CreateNomination',

  props: {
    isEdit: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data () {
    return {
      previewBlob: null,
      contactData: {
        title: null,
        description: null,
        image: null
      }
    }
  },

  watch: {
    '$store.getters.getDetailedNomination' () {
      const dataFromServer = this.$store.getters.getDetailedNomination

      this.contactData = {
        title: dataFromServer.title,
        description: dataFromServer.description
      }
      this.previewBlob = dataFromServer.image
      this.$forceUpdate()
    }
  },

  created () {
    if (this.isEdit) {
      this.$store.dispatch('setDetailedNomination', this.$route.params.id)
    }
  },

  methods: {
    createNomination () {
      const formData = new FormData()
      formData.append('title', this.contactData.title)
      formData.append('description', this.contactData.description)

      if (!this.isEdit) {
        formData.append('image', this.contactData.image)
        this.$store.dispatch('createNomination', formData)
      } else {
        if (this.contactData.image) {
          formData.append('image', this.contactData.image)
        }
        formData.append('_method', 'PUT')
        this.$store.dispatch('editNomination', {
          data: formData,
          id: this.$route.params.id
        })
      }
    },
    setFile (file) {
      this.previewBlob = null
      this.contactData.image = file
    }
  },
  components: {
    TricolorLine,
    CustomDropZone
  }
}
</script>

<style scoped lang="scss">
  @import "../../../assets/scss/utils/vars";

  .wysiwyg {
    width: 33.75rem;
  }

  .contacts__block {
    border-bottom: 1px solid #D5D6D9;
    margin-bottom: 1rem;

    header {
      margin-bottom: .75rem;
      display: flex;
      justify-content: space-between;
      align-items: center;

      > h4 {
        font-size: .875rem;
        line-height: 1.375rem;
      }

      > img {
        width: 1.5rem;
        height: 1.5rem;
        object-fit: contain;
        object-position: center;
        cursor: pointer;
      }
    }
  }

  .btns-create-form {
    border-top: 1px solid #D5D6D9;
    padding-top: 2.5rem;
    margin-top: 2.5rem;
  }

  .content-sb {
    margin-bottom: 1.25rem;

    span {
      color: red;
    }
  }

  .select, .input {
    width: 33.75rem;
  }

  .inputs__container {
    margin-bottom: 2rem;
    border-bottom: 1px solid #D5D6D9;
  }

  .content-blocks__container {
    display: flex;
    flex-direction: column;

    > .content-block {
      margin-bottom: 1.875rem;

      header {
        margin-bottom: .75rem;
        display: flex;
        justify-content: space-between;
        align-items: center;

        > h4 {
          font-size: .875rem;
          line-height: 1.375rem;
          color: $mainFontColor;
        }

        > img {
          width: 1.5rem;
          height: 1.5rem;
          object-fit: contain;
          object-position: center;
          cursor: pointer;
        }
      }

      .data-card {
        background: white;
        border: 1px solid #EBF3FF;
        box-sizing: border-box;
        box-shadow: 0 .9375rem 1.5625rem rgba(189, 205, 221, 0.15);
        border-radius: .5rem;
        padding: 1.25rem;
        width: 100%;
        min-height: 8.875rem;
      }
    }
  }

  .add-content-block__container {
    background-color: $neutral-placeholder;
    width: 100%;
    padding: 1.25rem;
    border-radius: .187rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    margin-top: .5rem;

    &:after {
      content: '';
      position: absolute;
      width: 1.5rem;
      height: 1.5rem;
      background-color: $neutral-placeholder;
      top: 0;
      left: 50%;
      transform: translate(-50%,-50%) rotate(45deg);
    }

    > .row {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 1.25rem;
    }

    > .btn-blue > img {
      width: 1.125rem;
      height: 1.125rem;
      object-fit: contain;
      object-position: center;
      margin-right: .5rem;
    }
  }
</style>
